(function () {
	"use strict";

	function initChatbot(root) {
		if (!root || root.dataset.bmChatbotReady === "true") {
			return;
		}

		var configEl = root.querySelector(".bm_chat_config_json");
		if (!configEl) {
			return;
		}

		var config = {};
		try {
			config = JSON.parse(configEl.textContent);
		} catch (error) {
			console.error("BM Chatbot config parse error", error);
			return;
		}

		var launcherArea = root.querySelector(".bm_chat_launcher_area");
		var launcher = root.querySelector(".bm_chat_launcher");
		var chatWindow = root.querySelector(".bm_chat_window");
		var chatBody = root.querySelector(".bm_chat_body");

		if (!launcherArea || !launcher || !chatWindow || !chatBody) {
			return;
		}

		var isOpen = false;
		var currentCategory = null;
		var categoryMap = {};
		var answerMap = {};
		var subQuestionMap = config.subQuestions || {};

		(config.categories || []).forEach(function (category) {
			categoryMap[category.id] = category;
		});

		Object.keys(config.answers || {}).forEach(function (key) {
			answerMap[key] = config.answers[key];
		});

		launcher.addEventListener("click", function () {
			isOpen = !isOpen;
			launcherArea.classList.toggle("is_active", isOpen);
			chatWindow.classList.toggle("is_open", isOpen);
			launcher.setAttribute(
				"aria-label",
				isOpen ? (config.labels && config.labels.close ? config.labels.close : "チャットを閉じる") : (config.labels && config.labels.open ? config.labels.open : "チャットサポートを開く")
			);

			if (isOpen && chatBody.children.length === 0) {
				startChat();
			}
		});

		root.dataset.bmChatbotReady = "true";

		function startChat() {
			chatBody.innerHTML = "";
			currentCategory = null;
			showBotMessage(config.initialMessage || "", function () {
				showCategoryOptions();
			});
		}

		function formatMessage(text) {
			var safe = escapeHtml(text || "");
			var withBr = safe.replace(/\n/g, "<br>");
			return withBr.replace(/(https?:\/\/[^\s<、。」]+)/g, function (url) {
				return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + url + "</a>";
			});
		}

		function showBotMessage(text, callback) {
			showTyping(function () {
				var msgDiv = document.createElement("div");
				msgDiv.className = "bm_msg bm_msg_bot";

				var bubble = document.createElement("div");
				bubble.className = "bm_msg_bubble";
				bubble.innerHTML = formatMessage(text);

				msgDiv.appendChild(bubble);
				chatBody.appendChild(msgDiv);
				scrollToBottom();

				if (callback) {
					setTimeout(callback, 100);
				}
			});
		}

		function showUserMessage(text) {
			var msgDiv = document.createElement("div");
			msgDiv.className = "bm_msg bm_msg_user";

			var bubble = document.createElement("div");
			bubble.className = "bm_msg_bubble";
			bubble.textContent = text || "";

			msgDiv.appendChild(bubble);
			chatBody.appendChild(msgDiv);
			scrollToBottom();
		}

		function showTyping(callback) {
			var typingDiv = document.createElement("div");
			typingDiv.className = "bm_typing";
			typingDiv.id = "bmTyping-" + Math.random().toString(36).slice(2);

			for (var i = 0; i < 3; i += 1) {
				var dot = document.createElement("div");
				dot.className = "bm_typing_dot";
				typingDiv.appendChild(dot);
			}

			chatBody.appendChild(typingDiv);
			scrollToBottom();

			setTimeout(function () {
				if (typingDiv && typingDiv.parentNode) {
					typingDiv.parentNode.removeChild(typingDiv);
				}
				if (callback) {
					callback();
				}
			}, config.typingDelay || 700);
		}

		function showCategoryOptions() {
			var container = document.createElement("div");
			container.className = "bm_options";

			(config.categories || []).forEach(function (category) {
				var btn = document.createElement("button");
				btn.type = "button";
				btn.className = "bm_option_btn";
				btn.textContent = category.label;
				btn.addEventListener("click", function () {
					handleCategorySelect(category);
				});
				container.appendChild(btn);
			});

			chatBody.appendChild(container);
			scrollToBottom();
		}

		function handleCategorySelect(category) {
			disableAllButtons();
			showUserMessage(category.label);
			currentCategory = category.id;

			if (category.id === "other") {
				showBotMessage(config.otherAnswer || "", function () {
					showNavButtons(false);
				});
				return;
			}

			showBotMessage((config.categoryLead || {})[category.id] || "", function () {
				showSubQuestionOptions(category.id);
			});
		}

		function showSubQuestionOptions(categoryId) {
			var questions = subQuestionMap[categoryId];

			if (!questions || !questions.length) {
				return;
			}

			var container = document.createElement("div");
			container.className = "bm_options";

			questions.forEach(function (question) {
				var btn = document.createElement("button");
				btn.type = "button";
				btn.className = "bm_option_btn";
				btn.textContent = question.label;
				btn.addEventListener("click", function () {
					handleQuestionSelect(question);
				});
				container.appendChild(btn);
			});

			chatBody.appendChild(container);
			scrollToBottom();
		}

		function handleQuestionSelect(question) {
			disableAllButtons();
			showUserMessage(question.label);

			var answer = answerMap[question.id];
			if (answer) {
				showBotMessage(answer, function () {
					showNavButtons(true);
				});
			}
		}

		function showNavButtons(showCategoryBack) {
			var container = document.createElement("div");
			container.className = "bm_nav_btns";

			if (showCategoryBack && currentCategory) {
				var backBtn = document.createElement("button");
				backBtn.type = "button";
				backBtn.className = "bm_nav_btn";
				backBtn.textContent = (config.labels && config.labels.back) ? config.labels.back : "他の質問を見る";
				backBtn.addEventListener("click", function () {
					disableAllButtons();
					showBotMessage((config.categoryLead || {})[currentCategory] || "", function () {
						showSubQuestionOptions(currentCategory);
					});
				});
				container.appendChild(backBtn);
			}

			var restartBtn = document.createElement("button");
			restartBtn.type = "button";
			restartBtn.className = "bm_nav_btn";
			restartBtn.textContent = (config.labels && config.labels.restart) ? config.labels.restart : "最初に戻る";
			restartBtn.addEventListener("click", function () {
				disableAllButtons();
				currentCategory = null;
				showBotMessage(config.initialMessage || "", function () {
					showCategoryOptions();
				});
			});
			container.appendChild(restartBtn);

			chatBody.appendChild(container);
			scrollToBottom();
		}

		function disableAllButtons() {
			var buttons = chatBody.querySelectorAll(".bm_option_btn, .bm_nav_btn");
			for (var i = 0; i < buttons.length; i += 1) {
				buttons[i].disabled = true;
				buttons[i].style.opacity = "0.45";
				buttons[i].style.pointerEvents = "none";
			}
		}

		function scrollToBottom() {
			window.requestAnimationFrame(function () {
				chatBody.scrollTop = chatBody.scrollHeight;
			});
		}

		function escapeHtml(text) {
			var div = document.createElement("div");
			div.textContent = text;
			return div.innerHTML;
		}
	}

	function boot() {
		var roots = document.querySelectorAll("[data-bm-chatbot]");
		for (var i = 0; i < roots.length; i += 1) {
			initChatbot(roots[i]);
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", boot);
	} else {
		boot();
	}
})();